// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiDrop } from '../models/ApiDrop';
import { ApiProfileMin } from '../models/ApiProfileMin';
import { ApiWaveChatConfig } from '../models/ApiWaveChatConfig';
import { ApiWaveConfig } from '../models/ApiWaveConfig';
import { ApiWaveContributorOverview } from '../models/ApiWaveContributorOverview';
import { ApiWaveDecisionPause } from '../models/ApiWaveDecisionPause';
import { ApiWaveMetrics } from '../models/ApiWaveMetrics';
import { ApiWaveParticipationConfig } from '../models/ApiWaveParticipationConfig';
import { ApiWaveSubscriptionTargetAction } from '../models/ApiWaveSubscriptionTargetAction';
import { ApiWaveVisibilityConfig } from '../models/ApiWaveVisibilityConfig';
import { ApiWaveVotingConfig } from '../models/ApiWaveVotingConfig';
import { HttpFile } from '../http/http';

export class ApiWave {
    /**
    * The ID of the wave
    */
    'id': string;
    /**
    * Sequence number of the wave in Seize
    */
    'serial_no': number;
    'author': ApiProfileMin;
    /**
    * The name of the wave
    */
    'name': string;
    /**
    * The picture of the wave
    */
    'picture': string | null;
    'created_at': number;
    /**
    * Unix timestamp in milliseconds of the most recent drop in this wave
    */
    'last_drop_time': number;
    'description_drop': ApiDrop;
    'voting': ApiWaveVotingConfig;
    'visibility': ApiWaveVisibilityConfig;
    'participation': ApiWaveParticipationConfig;
    'chat': ApiWaveChatConfig;
    'wave': ApiWaveConfig;
    'contributors_overview': Array<ApiWaveContributorOverview>;
    'subscribed_actions': Array<ApiWaveSubscriptionTargetAction>;
    'metrics': ApiWaveMetrics;
    'pauses': Array<ApiWaveDecisionPause>;
    'pinned': boolean;
    'identity_wave': boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "serial_no",
            "baseName": "serial_no",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "author",
            "baseName": "author",
            "type": "ApiProfileMin",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "picture",
            "baseName": "picture",
            "type": "string",
            "format": ""
        },
        {
            "name": "created_at",
            "baseName": "created_at",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "last_drop_time",
            "baseName": "last_drop_time",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "description_drop",
            "baseName": "description_drop",
            "type": "ApiDrop",
            "format": ""
        },
        {
            "name": "voting",
            "baseName": "voting",
            "type": "ApiWaveVotingConfig",
            "format": ""
        },
        {
            "name": "visibility",
            "baseName": "visibility",
            "type": "ApiWaveVisibilityConfig",
            "format": ""
        },
        {
            "name": "participation",
            "baseName": "participation",
            "type": "ApiWaveParticipationConfig",
            "format": ""
        },
        {
            "name": "chat",
            "baseName": "chat",
            "type": "ApiWaveChatConfig",
            "format": ""
        },
        {
            "name": "wave",
            "baseName": "wave",
            "type": "ApiWaveConfig",
            "format": ""
        },
        {
            "name": "contributors_overview",
            "baseName": "contributors_overview",
            "type": "Array<ApiWaveContributorOverview>",
            "format": ""
        },
        {
            "name": "subscribed_actions",
            "baseName": "subscribed_actions",
            "type": "Array<ApiWaveSubscriptionTargetAction>",
            "format": ""
        },
        {
            "name": "metrics",
            "baseName": "metrics",
            "type": "ApiWaveMetrics",
            "format": ""
        },
        {
            "name": "pauses",
            "baseName": "pauses",
            "type": "Array<ApiWaveDecisionPause>",
            "format": ""
        },
        {
            "name": "pinned",
            "baseName": "pinned",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "identity_wave",
            "baseName": "identity_wave",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiWave.attributeTypeMap;
    }

    public constructor() {
    }
}

